"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.esb = void 0;
const EsbBase_1 = require("../EsbBase/EsbBase");
const Utilities_1 = require("../../../../../TdWebtoolkitControls/javascript/Utilities");
class esb extends EsbBase_1.EsbBase {
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-font";
    }
    getOwnerGroup() {
        return Utilities_1.synUtil.Configs.getValueMandatory("esb.ownergroup.a");
    }
    getEsbCategories() {
        let cfgVal = Utilities_1.synUtil.Configs.getValueMandatory("esb.entrycategories.a");
        let arr = Utilities_1.synUtil.splitWithoutEmptyEntries(cfgVal, "|");
        return $.map(arr, (elem) => parseInt(elem, 10));
    }
}
exports.esb = esb;
